import Tabs from './TabsParts/tabs';
import TabContent from './TabsParts/tabContent';
import TabNav from './TabsParts/tabNav';

export { TabContent, TabNav };
export default Tabs;
